import React, { useCallback, useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { OrganisationResponse } from '../../../types/OrganisationInterfaces';
import { useHistory, useParams } from 'react-router-dom';
import UpsertOrganisationComponent from '../../components/organisations/UpsertOrganisationComponent';
import LoadingComponent from '../../components/shared/LoadingComponent';
import ErrorComponent from '../../components/shared/ErrorComponent';

const EditOrganisationPage = () => {
  const [isLoadingOrganisation, setIsLoadingOrganisation] = useState<boolean>(false);
  const [isOrganisationLoaded, setIsOrganisationLoaded] = useState<boolean>(false);
  const [organisation, setOrganisation] = useState<OrganisationResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const params = useParams<any>();
  const organisationId: number = Number(params.organisationId);

  /*
  const loadOrganisation = useCallback(async (): Promise<void> => {
    setIsLoadingOrganisation(true);
    setIsOrganisationLoaded(false);
    try {
      const response: OrganisationResponse = await OrganisationService.getOrganisation(organisationId);
      setOrganisation(response);
      setIsOrganisationLoaded(true);
    } catch (error) {
      setError(error.message);
    }

    setIsLoadingOrganisation(false);
  }, [setIsLoadingOrganisation, setIsOrganisationLoaded, setOrganisation, setError, organisationId]);

  useEffect(() => {
    if (!isLoadingOrganisation && !isOrganisationLoaded && !error) {
      loadOrganisation();
    }
  }, [isLoadingOrganisation, isOrganisationLoaded, error, loadOrganisation]);

  };

   */

  const history = useHistory();
  const goTo = (location: string) => {
    history.push(location);
  }
    return (
    <Grid container>
      <Grid item lg={12}>
        <Grid container sx={{ mb: 4 }}>
          <Grid item lg={6}>
            <Typography variant={'h4'}>Edit Organisation</Typography>
          </Grid>
          <Grid item lg={6} style={{ textAlign: 'right' }}>
            <Button variant={'outlined'} onClick={() => goTo(`/app/organisations/${organisationId}`)} startIcon={<ArrowBackIcon />}>
              Organisation
            </Button>
          </Grid>
        </Grid>

        {isLoadingOrganisation && <LoadingComponent />}
        {error && <ErrorComponent message={error} />}
        {isOrganisationLoaded && organisation && (
          <UpsertOrganisationComponent selectedOrganisation={organisation} selectedOrganisationId={organisationId} />
        )}
      </Grid>
    </Grid>
  );
};

export default EditOrganisationPage
